import React, { useEffect, useState } from "react";
//icons and images
import { BiSearch } from "react-icons/bi";
import { socket } from "../../../../configs/socket_export";
//components
import AeroButton from "../../../components/aeroButton/index";
//context
import { useUser } from "../../../context/allusers";
import addcontact from "./assets/add-contact.png";
import sortContacts from "./assets/sort-contacts.png";
import Contact from "./components/contact/index";
import { Container } from "./styles";

const Contacts = () => {
    const { contactsOnline, countContactsOnline } = useUser();
    const [requests, setRequests] = useState([]);
    const [outgoing, setOutgoing] = useState([]);
    const [friends, setFriends] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [addUsername, setAddUsername] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);
    const [searchError, setSearchError] = useState("");

    const loadFriends = async () => {
        try {
            const response = await fetch("/routes/friends/status", { credentials: "include" });
            const payload = await response.json();
            if (response.ok) setFriends(payload.friends || []);
        } catch (err) {
            setFriends([]);
        }
    };


    const loadOutgoing = async () => {
        try {
            const response = await fetch("/routes/friends/outgoing", { credentials: "include" });
            const payload = await response.json();
            if (response.ok) setOutgoing(payload.requests || []);
        } catch (err) {
            setOutgoing([]);
        }
    };
    const loadRequests = async () => {
        try {
            const response = await fetch("/routes/friends/requests", { credentials: "include" });
            const payload = await response.json();
            if (response.ok) setRequests(payload.requests || []);
        } catch (err) {
            setRequests([]);
        }
    };

    useEffect(() => {
        loadFriends();
        loadRequests();
        loadOutgoing();
        const refreshTimer = setInterval(loadFriends, 10000);
        return () => clearInterval(refreshTimer);
    }, []);

    const handleAddFriend = async (usernameOverride) => {
        const username = `${usernameOverride || addUsername}`.trim();
        if (!username) return;
        try {
            await fetch("/routes/friends/request", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({ username }),
            });
            setAddUsername("");
            loadRequests();
            loadOutgoing();
        } catch (err) {}
    };

    const handleRespond = async (requestId, action) => {
        try {
            await fetch("/routes/friends/respond", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({ requestId, action }),
            });
            loadRequests();
            loadOutgoing();
            loadFriends();
        } catch (err) {}
    };

    const handleSearch = async () => {
        const query = searchQuery.trim();
        setSearchError("");
        setSearchLoading(true);
        try {
            const response = await fetch(`/routes/users/search?query=${encodeURIComponent(query)}`);
            const payload = await response.json();
            if (!response.ok) {
                setSearchError("Search failed.");
                setSearchResults([]);
            } else {
                setSearchResults(payload.users || []);
            }
        } catch (err) {
            setSearchError("Search failed.");
            setSearchResults([]);
        }
        setSearchLoading(false);
    };


    const friendNames = new Set(friends.map((f) => f.username.toLowerCase()));
    const incomingNames = new Set(requests.map((r) => r.username.toLowerCase()));
    const outgoingNames = new Set(outgoing.map((r) => r.username.toLowerCase()));
    return (
        <Container>
            {showAddModal && (
                <div className="add-friend-overlay">
                    <div className="add-friend-modal">
                        <div className="add-friend-title">Add friend</div>
                        <input
                            type="text"
                            value={addUsername}
                            onChange={(e) => setAddUsername(e.target.value)}
                            placeholder="Username"
                            className="add-friend-input"
                        />
                        <div className="add-friend-actions">
                            <button type="button" className="add-friend-btn" onClick={() => setShowAddModal(false)}>
                                Close
                            </button>
                            <button type="button" className="add-friend-btn primary" onClick={() => handleAddFriend()}>
                                Send request
                            </button>
                        </div>
                        <div className="add-friend-search">
                            <div className="add-friend-subtitle">Find users online</div>
                            <div className="add-friend-search-row">
                                <input
                                    type="text"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    placeholder="Search username"
                                    className="add-friend-input"
                                />
                                <button type="button" className="add-friend-btn" onClick={handleSearch}>
                                    Search
                                </button>
                            </div>
                            {searchLoading && <small className="add-friend-muted">Searching...</small>}
                            {searchError && <small className="add-friend-error">{searchError}</small>}
                            {!searchLoading && !searchError && searchResults.length === 0 && (
                                <small className="add-friend-muted">No users found.</small>
                            )}
                            <div className="add-friend-results">
                                {searchResults.map((user) => {
                                    const key = user.username.toLowerCase();
                                    const isFriend = friendNames.has(key);
                                    const isIncoming = incomingNames.has(key);
                                    const isOutgoing = outgoingNames.has(key);
                                    const disabled = isFriend || isIncoming || isOutgoing;
                                    const label = isFriend ? "Friend" : isIncoming ? "Incoming" : isOutgoing ? "Requested" : "Add";
                                    return (
                                        <div key={user.username} className="add-friend-item">
                                            <span>{user.username}</span>
                                            <button type="button" className="add-friend-btn" disabled={disabled} onClick={() => handleAddFriend(user.username)}>
                                                {label}
                                            </button>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div id="search-contacts">
                <input type="text"></input>
                <AeroButton className="button" disabled={true}>
                    <BiSearch color="gray" />
                </AeroButton>
                <AeroButton className="button" onCustomClick={() => setShowAddModal(true)}>
                    <img src={addcontact} alt="" />
                </AeroButton>
                <AeroButton className="button" disabled={true}>
                    <img src={sortContacts} alt="" />
                </AeroButton>
            </div>
            <div id="contacts-list">
                <details className="contacts-group-list" open>
                    <summary>Friends ({friends.length})</summary>
                    <div id="contacts-group-list-contacts">
                        {friends.length === 0 && <small className="add-friend-muted">No friends yet.</small>}
                        {friends.map((friend) => (
                            <div key={friend.username} className="add-friend-item">
                                <span>{friend.username}</span>
                                <small className="add-friend-muted">{friend.status === "offline" ? "(offline)" : `(${friend.status})`}</small>
                                {friend.subnick ? <small className="add-friend-muted">- {friend.subnick}</small> : null}
                            </div>
                        ))}
                    </div>
                </details>
                <details className="contacts-group-list">
                    <summary>Requests ({requests.length})</summary>
                    <div id="contacts-group-list-contacts">
                        {requests.length === 0 && <small className="add-friend-muted">No pending requests.</small>}
                        {requests.map((req) => (
                            <div key={req.id} className="add-friend-item spaced">
                                <span>{req.username}</span>
                                <div>
                                    <button type="button" className="add-friend-btn" onClick={() => handleRespond(req.id, "accept")}>Accept</button>
                                    <button type="button" className="add-friend-btn" onClick={() => handleRespond(req.id, "decline")}>
                                        Decline
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </details>
                <details className="contacts-group-list">
                    <summary>Online ({countContactsOnline})</summary>
                    <div id="contacts-group-list-contacts">
                        {contactsOnline &&
                            contactsOnline.map((elem) => {
                                if (socket.id === elem.socketid) {
                                    return <Contact username={elem.username} status={elem.status} subnick={elem.subnick} socketid={elem.socketid} key={elem.socketid} music={elem.music} disabled={true} />;
                                }
                                if (elem.status !== "invisible") {
                                    return <Contact username={elem.username} status={elem.status} subnick={elem.subnick} socketid={elem.socketid} key={elem.socketid} music={elem.music} disabled={false} />;
                                }
                                return null;
                            })}
                        <small className="add-friend-muted">* Online users will appear in this list.</small>
                    </div>
                </details>
            </div>
        </Container>
    );
};

export default Contacts;
